"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Translates strings.
 */
class TypeHandlerString {
    fromRdf(literal) {
        return literal.value;
    }
    toRdf(value, { datatype, dataFactory }) {
        return dataFactory.literal(value, datatype);
    }
}
exports.TypeHandlerString = TypeHandlerString;
TypeHandlerString.TYPES = [
    'http://www.w3.org/2001/XMLSchema#string',
    'http://www.w3.org/2001/XMLSchema#normalizedString',
    'http://www.w3.org/2001/XMLSchema#anyURI',
    'http://www.w3.org/2001/XMLSchema#base64Binary',
    'http://www.w3.org/2001/XMLSchema#language',
    'http://www.w3.org/2001/XMLSchema#Name',
    'http://www.w3.org/2001/XMLSchema#NCName',
    'http://www.w3.org/2001/XMLSchema#NMTOKEN',
    'http://www.w3.org/2001/XMLSchema#token',
    'http://www.w3.org/2001/XMLSchema#hexBinary',
    'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString',
    'http://www.w3.org/2001/XMLSchema#time',
    'http://www.w3.org/2001/XMLSchema#duration',
];
//# sourceMappingURL=TypeHandlerString.js.map